import { FormControl, Grid, InputLabel, MenuItem, TextField, Typography } from '@mui/material'
import React, { useEffect } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { Industry } from '../../../../../Types/General';
import { useAppDispatch, useAppSelector } from '../../../../../Redux/store';
import { setIndustry, setNextDisabled, setWorkSite } from '../../Slices/TalentProfileCreationSlice';
import { useTalent } from '../../../../../Hooks/useTalent';

interface WorkPreferenceForm {
    // Industry: string;
    WorkSite: string;
}
export const WorkPreference = () => {
    /* ******************** Hooks ******************** */
    const dispatch = useAppDispatch();
    const { talent } = useTalent();
    const profileCreationSlice = useAppSelector( state => state.TalentProfileCreation)
    const {
        control,
        formState: {dirtyFields, errors},
        getValues,
        watch
    } = useForm<WorkPreferenceForm>({
        defaultValues: {
            // Industry: talent?.work_preferences?.industry ?? "",
            WorkSite: profileCreationSlice.workSite ||  talent?.work_preferences?.site || "",
        }
    })
    /* ******************** Variables ******************** */
    const watchFields = Object.values(watch())
    /* ******************** Functions ******************** */
    /* ******************** Effects ******************** */
    useEffect(()=>{
        return function cleanup() {
            // if (dirtyFields.Industry) dispatch(setIndustry(getValues('Industry')))
            if (dirtyFields.WorkSite) dispatch(setWorkSite(getValues('WorkSite')))
        }
    }, [dirtyFields])

    useEffect(()=>{
        if (watchFields.every( field => field.length > 0) && profileCreationSlice.nextDisabled) {
            dispatch(setNextDisabled(false));
        } 
        if (!watchFields.every( field => field.length > 0) && !profileCreationSlice.nextDisabled) {
            dispatch(setNextDisabled(true));
        } 
    }, [watchFields])
    /* ******************** JSX ******************** */
    return (
        <Grid container gap={'20px'}>
            <Typography variant='lora-title-large' color={'primary'} fontWeight={'bold'}>Add your work preference</Typography>
            <Grid item display={"flex"} flexDirection={"row"} gap={"12px"} width={"100%"}>
                {/* <Grid item display={"flex"} flexDirection={"column"}>
                    <Typography variant='body-small' color={'black.200'} marginBottom={1}>Industry type</Typography>  
                    <Controller
                        name="Industry"
                        control={control}
                        rules={{required: true}}
                        render={({ field }) =>( 
                            <FormControl>   
                                <InputLabel sx={{opacity: 1}}>{field.value ?"":"Industry"}</InputLabel>                   
                                <TextField
                                    {...field}
                                    // error={hasErrors(field.name, errors)}
                                    select
                                    sx={{
                                        width: "270px"
                                    }}
                                >
                                    {
                                        Industry.map((industry) => (
                                            <MenuItem key={industry} value={industry}>
                                                {industry}
                                            </MenuItem>
                                        ))
                                    }
                                </TextField>
                            </FormControl>
                        )}
                    />   
                </Grid> */}
                <Grid item display={"flex"} flexDirection={"column"} width={"100%"}>
                    <Typography variant='body-small' color={'black.200'} marginBottom={1}>Work-site location</Typography>  
                    <Controller
                        name="WorkSite"
                        control={control}
                        rules={{required: true}}
                        render={({ field }) =>( 
                            <FormControl>   
                                <InputLabel sx={{opacity: 1}}>{field.value ?"":"Work-site"}</InputLabel>                   
                                <TextField
                                    {...field}
                                    // error={hasErrors(field.name, errors)}
                                    select
                                    fullWidth
                                    sx={{
                                        minWidth: "270px"
                                    }}
                                >
                                    {
                                        [
                                            "Remote", 
                                            "In person", 
                                            "Hybrid"
                                        ].map((language) => (
                                            <MenuItem key={language} value={language}>
                                                {language}
                                            </MenuItem>
                                        ))
                                    }
                                </TextField>
                            </FormControl>
                        )}
                    />   
                </Grid>
            </Grid>
        </Grid>
    )
}